import {BallTriangle} from "react-loader-spinner";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";



export default function Loader(){
   
    return (
      <BallTriangle type="BallTriangle " color="#00BFFF" height={150} width={150}  />
    );
  
}


